<div class="padding fix-width flex column start">
	<b>Warehouse:</b>
	<span class="bg-orange padding-left-small padding-right-small margin-top-smallest">{{ data.warehouse?.description }}</span>

	<b class="margin-top-small">Selected products:</b>

	<div class="full-width fix-height scrollable flex column border dashed margin-top-smallest">
		@for (item of styles; track item) {
			<div class="flex column">
				<div class="flex between padding-smallest padding-left-small padding-right-small">
					<div class="flex flex-1">
						<div class="flex column flex-1">
							<div class="flex center between">
								{{ item.brand.name }} - {{ item.code }} - {{ item.name }}
								<span class="hover flex red center primary" (click)="openManageColorsSizesModal(item)">Manage colors/sizes</span>
							</div>

							<div class="grey">
								@for (color of item.colors; track color; let last = $last) {
									<div class="flex center">
										{{ color.code }} {{ color.name }}
										<span class="margin-left-smallest bg-light-grey padding-left-smallest padding-right-smallest radius">Size {{ color.size?.name }}</span>
									</div>
								} @empty {
									<span class="bg-orange">No colors selected</span>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		}
	</div>

	<b class="margin-top-small">Select an option:</b>
	<div class="flex gap margin-top-small full-width">
		<div class="bg-primary-dark white flex-1 flex column center padding-small radius hover" (click)="openCreateNewOrderModal()">
			<i class="fa-solid fa-plus fa-2xl padding"></i>
			<span class="margin-top-small nowrap">Create a new order</span>
		</div>

		<div class="bg-primary-dark white flex-1 flex column center padding-small radius hover" (click)="openAddToOrderModal()">
			<i class="fa-solid fa-file-import fa-2xl padding"></i>
			<span class="margin-top-small nowrap">Add style to existing order</span>
		</div>
	</div>

	<div class="flex full-width column end margin-top">
		<button class="stroked" (click)="close()">
			<i class="fa-solid fa-undo"></i>
			Close
		</button>
	</div>
</div>
